<template>
  <main class="redirect-wrapper flex items-center justify-center min-h-screen bg-slate-50 px-4">
    <div class="notice-card bg-white shadow-lg rounded-2xl max-w-lg w-full p-8 md:p-10 text-center relative overflow-hidden">
      <!-- Decorative Top Bar -->
      <div class="absolute top-0 left-0 w-full h-2 bg-agora-blue"></div>

      <!-- Language Switcher -->
      <div class="flex justify-center items-center gap-4 mb-8 text-sm font-bold text-slate-400">
        <button @click="lang = 'kr'" :class="{'text-agora-blue': lang === 'kr'}" style="font-family: 'Speda', sans-serif;">Kurmancî</button>
        <span>|</span>
        <button @click="lang = 'ku'" :class="{'text-agora-blue': lang === 'ku'}" style="font-family: 'Speda', sans-serif;">کوردی سۆرانی</button>
        <span>|</span>
        <button @click="lang = 'en'" :class="{'text-agora-blue': lang === 'en'}" class="font-montserrat">English</button>
      </div>

      <!-- Icon / Avatar -->
      <div class="mx-auto w-16 h-16 bg-agora-blue-light rounded-full flex items-center justify-center mb-6">
        <svg class="w-8 h-8 text-agora-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
        </svg>
      </div>

      <!-- Notice Content -->
      <div :dir="currentContent.dir" :class="currentContent.fontClass">
        <h1 class="text-2xl md:text-3xl font-bold text-slate-800 mb-4 tracking-tight">
          {{ currentContent.title }}
        </h1>
        
        <p class="text-slate-500 mb-8 leading-relaxed text-sm md:text-base">
          {{ currentContent.bodyStart }}
          <strong class="text-agora-blue font-bold">{{ currentContent.brandOld }}</strong>
          {{ currentContent.bodyMiddle }}
          <strong class="text-agora-blue font-bold">{{ currentContent.brandNew }}</strong>{{ currentContent.bodyEnd }}
        </p>

        <!-- Action Button -->
        <a href="https://www.agoravision.site/visionenglish" class="siteBtn inline-block w-full md:w-4/5 mx-auto transition-transform hover:-translate-y-1">
          {{ currentContent.button }}
        </a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'SiteNotice',
  data() {
    return {
      // Default language can be set to what your global store usually defaults to
      lang: 'en',
      translations: {
        en: {
          dir: 'ltr',
          fontClass: 'font-montserrat',
          title: 'We have moved!',
          bodyStart: 'To provide you with a more unified and seamless experience, ',
          brandOld: 'Agora Warger',
          bodyMiddle: ' has been officially integrated and is now ',
          brandNew: 'Agora Vision English',
          bodyEnd: '.',
          button: 'Continue to Agora Vision English'
        },
        ku: {
          dir: 'rtl',
          fontClass: 'font-speda',
          title: 'ماڵپەڕەکەمان گواستراوەتەوە!',
          bodyStart: 'لەپێناو پێشکەشکردنی ئەزموونێکی یەکگرتوو و باشتر، ',
          brandOld: 'ئاگۆرا وەرگێڕ',
          bodyMiddle: ' بە فەرمی تێکەڵ کراوە و ئێستا بووەتە ',
          brandNew: 'ئاگۆرا ڤیژن ئینگلیزی',
          bodyEnd: '.',
          button: 'بەردەوام بە بۆ ئاگۆرا ڤیژن ئینگلیزی'
        },
        kr: {
          dir: 'ltr',
          fontClass: 'font-speda',
          title: 'Malpera me hat guhastin!',
          bodyStart: 'Ji bo pêşkêşkirina ezmûneke yekbûyî û baştir, ',
          brandOld: 'Agora Warger',
          bodyMiddle: ' bi fermî hat yekkirin û niha bûye ',
          brandNew: 'Agora Vision English',
          bodyEnd: '.',
          button: 'Berdewam bike bo Agora Vision English'
        }
      }
    }
  },
  computed: {
    currentContent() {
      return this.translations[this.lang];
    }
  }
}
</script>

<style scoped>
.font-montserrat {
  font-family: "Montserrat", sans-serif;
}

.font-speda {
  font-family: "Speda", sans-serif;
}

.text-agora-blue {
  color: #422881;
}

.bg-agora-blue {
  background-color: #422881;
}

.bg-agora-blue-light {
  background-color: rgba(66, 40, 129, 0.1);
}

.siteBtn {
  height: 48px;
  background-color: #422881;
  font-weight: 700;
  color: white;
  text-decoration: none;
  line-height: 48px;
  border-radius: 5px;
  box-shadow: 0px 4px 12px rgba(66, 40, 129, 0.25);
  text-align: center;
}


</style>